import Service from '@/service/building'
import { handleItems } from './utils'

export default {
    data () {
        return {
            recommend_items: [],
            show_recommend: false
        }
    },
    methods: {
        checkRecommend (type, items, zone) {
            if (items.length === 0 && zone) {
                this.getAllCommentsBuildings(type)
                this.show_recommend = true
            } else {
                this.show_recommend = false
            }
        },
        async getAllCommentsBuildings (type) {
            const { items } = await Service.getBuildingRanks(type, '')
            this.recommend_items = handleItems(items)
        },
    }
}